import { graphql } from 'gql';

export const uercUpdateCalculationOtherCostGql = graphql(`
    mutation uercUpdateCalculationOtherCost($id: Long!, $input: UercCalculationOtherCostInput!) {
        uercUpdateCalculationOtherCost(id: $id, input: $input) {
            data {
                file {
                    name
                    count
                    size
                    dataUrl
                }
                hasEmptyOtherCostType
                hasEmptyFormula
                id
                uniqueId
                calculationId
                catalogOtherCostTypeId
                catalogOtherCostType {
                    canDelete
                    isSystem
                    id
                    uniqueId
                    name
                }
                globalOtherCostId
                name
                key
                calculatingType
                calculatingTypeValue
                chapter
                section
                isEditable
                formula
                limits {
                    constructionTypeId
                    seasonId
                    cost
                }
                constructionTypes {
                    constructionTypeId
                    constructionType {
                        id
                        code
                        name
                        shortName
                        catalogId
                        fullName
                        contractFileName
                        createdAt
                    }
                    distributionMethod
                }
            }
            result
            message
            code
            buttonText
            hideValidation
            hasValidation
            validation {
                property
                message
                metadata
            }
            actionRequired
        }
    }
`);

export const uercCalculationOtherCostForUpdateGql = graphql(`
    query uercCalculationOtherCostForUpdate($calculationId: Long!, $otherCostId: Long!, $editConstructionTypeId: Int) {
        uercCalculationOtherCostForUpdate(
            calculationId: $calculationId
            otherCostId: $otherCostId
            editConstructionTypeId: $editConstructionTypeId
        ) {
            data {
                calculatingType
                calculatingTypeValue
                calculationId
                catalogOtherCostType {
                    id
                    name
                    uniqueId
                }
                catalogOtherCostTypeId
                chapter
                constructionTypes {
                    constructionType {
                        code
                        id
                        name
                        shortName
                        catalogId
                        fullName
                        contractFileName
                        createdAt
                    }
                    constructionTypeId
                    distributionMethod
                    totalCostLimit
                }
                file {
                    count
                    dataUrl
                    name
                    size
                }
                formula
                globalOtherCostId
                hasEmptyFormula
                hasEmptyOtherCostType
                id
                isEditable
                key
                limits {
                    constructionTypeId
                    cost
                    seasonId
                }
                name
                section
                uniqueId
                hasCalculatingParticipation
                isLimitsTotalFromFile
                isManualLimitsDistribution
            }
            actionRequired
            buttonText
            code
            hasValidation
            hideValidation
            message
            result
            validation {
                property
                message
            }
        }
    }
`);

export const uercCalculationOtherCostTypesGql = graphql(`
    query uercCalculationOtherCostTypesQuery(
        $skip: Int
        $take: Int
        $calculationId: Long!
        $otherCostId: Long
        $where: CatalogOtherCostTypeDataFilterInput
        $order: [CatalogOtherCostTypeDataSortInput!]
    ) {
        uercCalculationOtherCostTypesQuery(
            skip: $skip
            take: $take
            calculationId: $calculationId
            otherCostId: $otherCostId
            where: $where
            order: $order
        ) {
            pageInfo {
                hasNextPage
                hasPreviousPage
            }
            items {
                canDelete
                isSystem
                id
                uniqueId
                name
            }
            totalCount
        }
    }
`);
